
export const orderManagementTabConstants = {
  ACTION_REQUIRED: 'ACTION_REQUIRED',
  ON_HOLD: 'ON_HOLD',
  READY_FOR_ALLOCATION: 'READY_FOR_ALLOCATION',
  READY_FOR_PRODUCTION: 'READY_FOR_PRODUCTION',
  SENT_FOR_PRODUCTION: 'SENT_FOR_PRODUCTION',
  REJECTED: 'REJECTED',
  PRODUCTION_ON_HOLD: 'PRODUCTION_ON_HOLD',
  CAD: 'CAD',
  CAD_HISTORY: 'CAD_HISTORY'
}

export const orderManagementScreenConstants = {
  IN_HOUSE: 'IN_HOUSE',
  OUTSOURCED: 'OUTSOURCED',
  REJECTED: 'REJECTED'
}
